export const TOAST_EVENT = {
  SUCCESS: 'ToastSuccess',
  ERROR: 'ToastError',
};

type ToastDetail = {
  title: string;
  message: string;
};

export function broadcastToast(type: string, title, message: string) {
  const event = new CustomEvent<ToastDetail>(type, {
    detail: { title, message },
    bubbles: true, // Allows the event to bubble up the DOM
    cancelable: true,
  });

  window.dispatchEvent(event);
}

export function broadcastError(title: string, message: string) {
  broadcastToast(TOAST_EVENT.ERROR, title, message);
}

export function broadcastSuccess(title: string, message: string) {
  broadcastToast(TOAST_EVENT.SUCCESS, title, message);
}
